// src/fir// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAtMFJiD6uwNpWlL-3fVY7219ruq_wHOdE",
  authDomain: "riceroma202606.firebaseapp.com",
  projectId: "riceroma202606",
  storageBucket: "riceroma202606.firebasestorage.app",
  messagingSenderId: "389887658012",
  appId: "1:389887658012:web:b768b7a616e939b69af7d9",
  measurementId: "G-3Z3R210HJT"
};

const app = initializeApp(firebaseConfig); // 重要：初始化

const auth = getAuth(app); // 用 app 来创建 auth
const db = getFirestore(app);

export { app, auth, db };
